import { toast } from "react-toastify";

const useToast = () => {
  const successConfig = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const infoConfig = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const editToast = () => {
    toast.info(
      "Os formulários não são obrigatórios! Altere apenas o que achar necessário!",
      infoConfig
    );
  };

  const putToast = () => {
    toast.success("Informações atualizadas com sucesso!!", successConfig);
  };

  const putCoverToast = () => {
    toast.success("Capa atualizada com sucesso!!", successConfig);
  };

  const putAvatarToast = () => {
    toast.success("Avatar atualizado com sucesso!!", successConfig);
  };

  const putStyleToast = () => {
    toast.success("Estilo Atualizado com sucesso!!", successConfig);
  };

  const postPageToast = () => {
    toast.success("Página criada com sucesso!!", successConfig);
  };

  const errorToast = () => {
    toast.error("Erro ao logar!", successConfig);
  };

  const postImagesToast = () => {
    toast.success("Imagens adicionadas com sucesso!!", successConfig);
  };

  const postStyleToast = () => {
    toast.success("Estilo personalizado com sucesso!!", successConfig);
  };

  const postLinkToast = () => {
    toast.success("Link adicionado com sucesso!!", successConfig);
  };

  const postScriptToast = () => {
    toast.success("Script adicionado com sucesso!!", successConfig);
  };

  const deleteLinkToast = () => {
    toast.success("Link removido com sucesso!!", successConfig);
  };

  const deleteScriptToast = () => {
    toast.success("Script removido com sucesso!!", successConfig);
  };

  return {
    putToast,
    postPageToast,
    errorToast,
    postImagesToast,
    postStyleToast,
    postLinkToast,
    postScriptToast,
    putCoverToast,
    putAvatarToast,
    putStyleToast,
    editToast,
    deleteLinkToast,
    deleteScriptToast,
  };
};

export default useToast;
